import { Report1914Container } from "../../../containers/borrowSystem/Report/Report1914Container";

export function Report1914Page() {
    return (
        <Report1914Container />
    )
}